import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-605874ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "stage-table-wrap",
  ref: "wrapRef"
}
const _hoisted_2 = {
  class: "stage-table-box",
  ref: "boxRef"
}
const _hoisted_3 = { class: "stage-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "col-temp" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-mood" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-signal" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-position" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "温度", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "市场情绪", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "信号", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "仓位建议", -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("thead", null, [
          _createElementVNode("tr", {
            style: _normalizeStyle(_ctx.headRowHeight > 0 ? { height: _ctx.headRowHeight + 'px' } : undefined)
          }, _hoisted_9, 4)
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages, (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.tier,
              class: _normalizeClass({ active: _ctx.activeTier === row.tier }),
              style: _normalizeStyle(_ctx.getRowStyle(row.tier))
            }, [
              _createElementVNode("td", {
                class: _normalizeClass('tier-' + row.tier)
              }, _toDisplayString(row.min) + "-" + _toDisplayString(row.max), 3),
              _createElementVNode("td", {
                class: _normalizeClass('tier-' + row.tier)
              }, _toDisplayString(row.label), 3),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["signal", row.signalClass])
                }, _toDisplayString(row.signal), 3)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["stage-tone", row.signalClass])
                }, _toDisplayString(row.position), 3)
              ])
            ], 6))
          }), 128))
        ])
      ])
    ], 512)
  ], 512))
}